module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('v-dialog'), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "modal-confirm",
      "classes": ['v--modal', 'modal-confirm'],
      "pivot-y": 0.2,
      "width": 400,
      "height": 125
    }
  }, [_c('div', {
    staticClass: "confirm-modal-content"
  }, [_c('div', {
    staticClass: "modal-title"
  }, [_c('h6', [_vm._v("Voulez-vous désactiver l'utilisateur "), _c('b', [_vm._v(_vm._s(this.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-button"
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.$modal.hide('modal-confirm')
      }
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.destroy
    }
  }, [_vm._v("Confirmer")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row main-wrap"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "section-bg"
  }, [_c('div', {
    staticClass: "create-btn"
  }, [_c('button', {
    staticClass: "green-btn create",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.clear
    }
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hid-den": "true"
    }
  }), _vm._v("\n\t\t\t\t\t\t\tCréer un profil\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-bordered",
    attrs: {
      "data-filtering": "false"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.allUtilisateurs), function(utilisateur) {
    return _c('tr', {
      staticClass: "table-row",
      on: {
        "click": [function($event) {
          return _vm.fill(utilisateur, $event)
        }, function($event) {
          _vm.disabled = 1
        }]
      }
    }, [_c('td', [_vm._v(_vm._s(utilisateur.user.name) + " " + _vm._s(utilisateur.user.surename))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(utilisateur.role))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(utilisateur.user.email))])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(3), _vm._v(" "), (_vm.display) ? _c('div', {
    staticClass: "section-bg default-form"
  }, [_vm._m(4)]) : _c('form', {
    staticClass: "section-bg",
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": _vm.submitForm
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-4 col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Prénom")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "name",
      "required": ""
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-4 col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "surname"
    }
  }, [_vm._v("Nom")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.surname),
      expression: "surname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "surname",
      "required": ""
    },
    domProps: {
      "value": (_vm.surname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.surname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-4 col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Type d'accès")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Choisir un type d'acces",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Choisissez un type d'accès")]), _vm._v(" "), _vm._l((_vm.types), function(t) {
    return _c('option', {
      domProps: {
        "value": t.value
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(t.text) + "\n\t\t\t\t\t\t\t\t")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-4 col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "role"
    }
  }, [_vm._v("Poste")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.role),
      expression: "role"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.role = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Choisir un role",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Choisissez un Poste")]), _vm._v(" "), _vm._l((_vm.roles), function(role) {
    return _c('option', {
      domProps: {
        "value": role.value
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(role.text) + "\n\t\t\t\t\t\t\t\t")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-4 col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), (_vm.removeUser === '') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }) : (_vm.removeUser === true) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "password",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-4 col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("E-mail")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "email",
      "placeholder": "gavin.belson@hooli.com",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "wrap col-sm-12"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.removeUser),
      expression: "removeUser"
    }],
    attrs: {
      "id": "check",
      "type": "checkbox",
      "name": "check",
      "value": "check"
    },
    domProps: {
      "checked": Array.isArray(_vm.removeUser) ? _vm._i(_vm.removeUser, "check") > -1 : (_vm.removeUser)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.removeUser,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "check",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.removeUser = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.removeUser = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.removeUser = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "check"
    }
  }, [_vm._v("Désactiver le profil")])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group time-div"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solde),
      expression: "solde"
    }],
    staticClass: "form-control time-input",
    class: {
      disabled: _vm.disabled
    },
    attrs: {
      "type": "number",
      "min": "1",
      "id": "solde",
      "disabled": _vm.disabled == 1 ? true : false,
      "required": ""
    },
    domProps: {
      "value": (_vm.solde)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.solde = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "solde"
    }
  }, [_vm._v("Solde du compte-temps")]), _vm._v(" "), (_vm.disabled == true) ? _c('span', {
    staticClass: "update",
    on: {
      "click": _vm.modify
    }
  }, [_vm._v("Modifier")]) : _vm._e(), _vm._v(" "), (_vm.disabled == false) ? _c('span', {
    staticClass: "update",
    on: {
      "click": _vm.cancel_modify
    }
  }, [_vm._v("Annuler")]) : _vm._e()]), _vm._v(" "), _c('hr', {
    staticClass: "hr-text",
    attrs: {
      "data-content": "clients assignés"
    }
  }), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._l((_vm.allClients), function(client) {
    return _vm._l((client.utilisateur), function(utilisateurclient) {
      return (_vm.utilisateur && _vm.utilisateur.id == utilisateurclient.id) ? _c('div', {
        directives: [{
          name: "key",
          rawName: "v-key",
          value: (utilisateurclient),
          expression: "utilisateurclient"
        }],
        staticClass: "row clients-assignes-content"
      }, [_c('div', {
        staticClass: "col-xs-8"
      }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(client.user.name) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-4 text-center"
      }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(client.utilisateur[_vm.utilisateur.id].temps.temps) + "\n\t\t\t\t\t\t\t")])]) : _vm._e()
    })
  }), _vm._v(" "), _vm._m(6)], 2)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title row"
  }, [_c('div', [_c('h1', [_vm._v("Gestion des utilisateurs"), _c('i', {
    staticClass: "fa fa-refresh fa-spin",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "onglet"
  }, [_c('h3', [_vm._v("Liste des utilisateurs")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "data-toggle": "true"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tNom de l'utilisateur\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', [_vm._v("\n\t\t\t\t\t\t\t\t\tPoste\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', {
    attrs: {
      "data-sortable": "false",
      "data-breakpoints": "x-small medium"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tMail\n\t\t\t\t\t\t\t\t")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "onglet"
  }, [_c('h3', [_vm._v("Profil d'utilisateur")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ligne"
  }), _vm._v(" "), _c('p', [_vm._v("Créer, modifier ou supprimer un utilisateur")]), _vm._v(" "), _c('div', {
    staticClass: "ligne"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row clients-assignes-titre"
  }, [_c('div', {
    staticClass: "col-xs-8"
  }, [_vm._v("Client")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 text-center"
  }, [_vm._v("Jours vendus")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "submit-btn"
  }, [_c('button', {
    staticClass: "green-btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Sauvegarder")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-288e169a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./assets/components/Users.vue
// module id = 198
// module chunks = 0